import { ExplosionAnimationController } from './ExplosionAnimationController';
import Phaser from 'phaser';
import { ATLAS } from './SpriteExtractionConfig';
import { WORLD_COLORS, TILE } from '../constants';
import { CharacterAnimationManager } from './CharacterAnimationManager';

export class SpriteAtlasLoader {
  static preload(scene: Phaser.Scene): void {
    const base = import.meta.env.BASE_URL;
    scene.load.atlas('winter', `${base}assets/winter/atlas.png`, `${base}assets/winter/atlas.json`);
    for (const theme of ['penguin', 'walker']) scene.load.atlas(theme, `${base}assets/${theme}-characters/atlas.png`, `${base}assets/${theme}-characters/atlas.json`);
    scene.load.atlas(ATLAS, `${base}assets/sprites/atlas.png`, `${base}assets/sprites/atlas.json`);
  }

  static create(scene: Phaser.Scene): void {
    for (let world = 0; world < WORLD_COLORS.length; world++) {
      for (const [kind, frame] of [['floor_a', 'sand'], ['floor_b', 'sand'], ['wall', 'stone'], ['block', 'crate']]) {
        this.createTile(scene, `tex_${kind}_w${world}`, ATLAS, `tiles/${frame}`, kind);
      }
    }
    for (const [kind, frame] of [['floor_a', 'sand'], ['floor_b', 'sand-alt'], ['wall', 'stone'], ['block', 'crate']]) {
      this.createTile(scene, `ice_${kind}`, 'winter', `tiles/${frame}`, kind);
    }
    for (const [kind,frame] of [['floor_a','sand'],['floor_b','sand'],['wall','stone'],['block','crate']]) this.createTile(scene,`walker_${kind}`,kind.startsWith('floor') ? ATLAS : 'walker',`tiles/${frame}`,kind);
    CharacterAnimationManager.register(scene);
    ExplosionAnimationController.register(scene);
    for (const texture of [ATLAS, 'winter', 'walker']) {
      scene.anims.create({ key: texture === ATLAS ? 'crate:break' : `${texture}:crate:break`, frames: [0, 1, 2].map(i => ({ key: texture, frame: `obstacles/crate-break/${i}` })), duration: 400 });
    }
  }

  private static createTile(scene: Phaser.Scene, key: string, atlas: string, frame: string, kind: string): void {
    const f = scene.textures.getFrame(atlas, frame);
    const canvas = scene.textures.createCanvas(key, TILE, TILE)!;
    const ctx = canvas.getContext();
    const image = f.source.image as HTMLImageElement;
    // Fit the actual artwork, without magnifying the transparent 224px sprite cell.
    const sourceCanvas = document.createElement('canvas'); sourceCanvas.width = f.cutWidth; sourceCanvas.height = f.cutHeight;
    const source = sourceCanvas.getContext('2d')!;
    source.drawImage(image, f.cutX, f.cutY, f.cutWidth, f.cutHeight, 0, 0, f.cutWidth, f.cutHeight);
    const data = source.getImageData(0, 0, f.cutWidth, f.cutHeight).data;
    let left = f.cutWidth, top = f.cutHeight, right = 0, bottom = 0;
    for (let y = 0; y < f.cutHeight; y++) for (let x = 0; x < f.cutWidth; x++) {
      if (data[(y * f.cutWidth + x) * 4 + 3] > 80) {
        left = Math.min(left, x); top = Math.min(top, y); right = Math.max(right, x + 1); bottom = Math.max(bottom, y + 1);
      }
    }
    const floor = kind.startsWith('floor');
    ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
    ctx.fillStyle = atlas !== 'winter' ? '#efd29a' : '#b9e2f3'; ctx.fillRect(0, 0, TILE, TILE);
    if (floor) {
      // A continuous base with quieter detail keeps actors and powerups readable.
      if (atlas !== 'winter') {
        // Sample open sand rather than repeating a large starfish on every walkable cell.
        const width = right-left, height = bottom-top;
        ctx.drawImage(sourceCanvas, left+width*0.15, top+height*0.08, width*0.7, height*0.2, 0, 0, TILE, TILE);
        ctx.strokeStyle = '#cfab6c30';ctx.lineWidth = 1;ctx.strokeRect(0.5,0.5,TILE-1,TILE-1);
      } else {
        ctx.drawImage(sourceCanvas, left, top, right-left, bottom-top, -1, -1, TILE+2, TILE+2);
      }
      ctx.fillStyle = atlas !== 'winter' ? '#efd29a38' : '#c9ebf52b'; ctx.fillRect(0, 0, TILE, TILE);
    } else {
      ctx.fillStyle = '#10243732';ctx.beginPath();ctx.ellipse(32,56,27,6,0,0,Math.PI*2);ctx.fill();
      ctx.drawImage(sourceCanvas, left, top, right-left, bottom-top, 2, 0, TILE-4, TILE-2);
    }
    canvas.refresh();
  }
}
